<div style="min-height:50vh" (mouseenter)="this.dotComService.DisplaySubMenu('')">
  <!-- login Modal -->
  <app-myharrellsloginprompt></app-myharrellsloginprompt>
  <!-- End login Modal -->
    <!-- SDS/Label Modal -->
    <div id="sdsLabelModal" class="modal">
        <!-- Modal content -->
        <div class="modal-content">
            <div class="row whiteBackground mt-5 text-center">
                <h2 class="Caecilia76BoldItalic greenText" style="font-size: 24px; font-weight: 700;">Select The Button
                    For The Legacy Document You Wish To View</h2>
            </div>
            <div class="row mt-3">
                <div class="col-md-12 text-center">
                    <input Class="DIN2014Regular"
                        style="display:inline;font-size:16px;line-height:20px; letter-spacing:.32px;height:40px;width:240px;padding:12px; text-align: center;"
                        placeholder="SKU# (Item Number)" (keyup)="SKUChanged()" (change)="SKUChanged()"
                        [(ngModel)]="skuNumber">
                </div>
            </div>
            <div class="row DIN2014Regular blueText mt-3 mb-3" *ngIf="productResults.length>0"
                style="border:solid 1px grey;text-align:center; font-size:19px; font-weight:400; line-height: 32px;"
                (click)="GetSDS(skuNumber)"><span style="cursor:pointer">{{productsSDS}}</span>
            </div>
            <div class="row DIN2014Regular blueText mb-3" *ngIf="productResults.length>0"
                style="border:solid 1px grey;text-align:center; font-size:19px; font-weight:400; line-height: 32px;"
                (click)="GetLabel(skuNumber)"><span style="cursor:pointer">{{productsLabel}}</span>
            </div>
            <div class="row DIN2014Regular blueText mb-3" *ngIf="productResults.length>0"
                style="border:solid 1px grey;text-align:center; font-size:19px; font-weight:400; line-height: 32px;"
                (click)="GetMetal(skuNumber)"><span style="cursor:pointer">{{productsMetal}}</span>
            </div>
            <div class="row whiteBackground">
                <h3 class="DIN2014Regular blackText"
                    style="text-align: justify; font-size: 14px; line-height: 20px; letter-spacing: .38px;">
                    The product information displayed in these search results is provided “AS IS,” without warranty
                    express or implied, and for information purposes only. Although we endeavor to present current and
                    accurate information, search results contain information created and maintained by a variety of
                    external sources that may not be current or complete. We do not control, monitor or guarantee the
                    timeliness or accuracy of the information provided by such external sources. Inclusion of a product
                    in a search result does not constitute our endorsement of that product. It is your responsibility to
                    review the official manufacturer product label information, applicable regulations, and otherwise
                    research the accuracy, completeness and usefulness of all information, claims and opinions contained
                    in these search results. In no event will we or our data providers be responsible or liable directly
                    or indirectly for any damage or loss caused or alleged to be caused by or in connection with the use
                    of or reliance on any information contained in these search results, including information that is
                    outdated or incorrect. The search results are provided under a limited non-exclusive, revocable,
                    nontransferable license, and may not be redistributed or used to develop a stand-alone database.
                    Further, the search results may include materials covered by registered copyrights and trademarks.
                    All rights not expressly granted herein are reserved by the intellectual property owners. In no
                    event shall the liability of CDMS, its officers, directors and agents hereunder exceed $100 (USD) in
                    the aggregate</h3>
            </div>
            <div class="row whiteBackground">
                <h6 class="mt-3" style="text-align: right;"><a class="DIN2014 greenBackground whiteText"
                        style="font-size:20px; font-weight: 700; padding:8px; text-decoration: none !important"
                        (click)="CloseSDSLabelModal()">Close</a></h6>
            </div>
        </div>



        <div class="alert alert-warning" role="alert" *ngIf="labelNoticeModal"
            style="position:fixed; bottom:45%; width:90%; margin-left:5%">
            <h6 style="display:inline">No Label found! Please contact inventory&#64;harrells.com to see if a Label
                is
                available for {{skuNumber}}</h6>
            <h6 style="display:inline;float:right;" (click)="HideLabelNotFoundNotice()">X</h6>
        </div>
        <div class="alert alert-warning" role="alert" *ngIf="sdsNoticeModal"
            style="position:fixed; bottom:45%; width:70%; margin-left:15%">
            <h6 style="display:inline">No SDS found! Please contact inventory&#64;harrells.com to see if a SDS is
                available for {{skuNumber}}</h6>
            <h6 style="display:inline;float:right;" (click)="HideSDSNotFoundNotice()">X</h6>
        </div>
        <div class="alert alert-warning" role="alert" *ngIf="metalNoticeModal"
            style="position:fixed; bottom:45%; width:70%; margin-left:15%">
            <h6 style="display:inline">No Metal docuument found! Please contact inventory&#64;harrells.com to see if a
                Metal document is
                available for {{skuNumber}}</h6>
            <h6 style="display:inline;float:right;" (click)="HideMetalNotFoundNotice()">X</h6>
        </div>
    </div>
    <!-- End SDS/Label Modal -->

    <div class="alert alert-danger" role="alert" *ngIf="displayFailureAlert"
        style="position:fixed; bottom:45%; width:70%; margin-left:15%">
        <h5 class="H5Normal" style="display:inline">{{this.failureText}}</h5>
        <h5 class="H5Normal" style="display:inline;float:right;" (click)="HideFailureAlert()">X</h5>
    </div>
    <div class="alert alert-warning" role="alert" *ngIf="labelNotice"
        style="position:fixed; bottom:45%; width:90%; margin-left:5%">
        <h6 style="display:inline">No Label found! Please contact inventory&#64;harrells.com to see if a Label
            is
            available for {{skuNumber}}</h6>
        <h6 style="display:inline;float:right;" (click)="HideLabelNotFoundNotice()">X</h6>
    </div>
    <div class="alert alert-warning" role="alert" *ngIf="sdsNotice"
        style="position:fixed; bottom:45%; width:70%; margin-left:15%">
        <h6 style="display:inline">No SDS found! Please contact inventory&#64;harrells.com to see if a SDS is
            available for {{skuNumber}}</h6>
        <h6 style="display:inline;float:right;" (click)="HideSDSNotFoundNotice()">X</h6>
    </div>
    <div class="row mt-5 mb-5" style="width:70%; max-width:1500px; margin:auto">
        <div class="col-12 mt-3">
            <h3 class="Caecilia76BoldItalic greenText"
                style="font-size: 36px; font-weight: 700; letter-spacing: -.72px;text-align:center">Search Harrell's
            </h3>
        </div>
        <div class="col-12 text-center">
            <input Class="DIN2014Regular"
                style="display:inline;font-size:16px;line-height:20px; letter-spacing:.32px;height:40px;width:300px; padding:12px; text-align: left;"
                placeholder="Key at least 3 characters" (keyup.enter)="SearchFired()"
                [(ngModel)]="dotComService.searchTerm">
            <img src="{{this.resourceImagePaths + 'search-normal.png'}}" alt="Search Icon"
                style="cursor:pointer;display:inline;margin-left:-40px">
        </div>
        <!-- products found from search term -->
        <div *ngIf="productResults.length>0" class="row mt-3 mb-5" style="margin-left:10px">
            <h4 class="Caecilia76BoldItalic blackText" style="font-size:26px; font-weight:700">
                Products
            </h4>
            <div class="row DIN2014Regular blackText mb-3" *ngIf="productResults.length>0"
                style="text-align:center; font-size:20px; font-weight:700; padding:8px;margin-left:0px"
                (mouseover)="this.OverLabelButton(true)" (mouseout)="this.OverLabelButton(false)"
                [ngStyle]="{'background-color': isHovered ? 'gray' : 'white', 'border': isHovered ? '1px solid gray' : '1px solid gray', 'color' : isHovered ? 'white' : 'gray'}"
                (click)="this.OpenSDSLabelModal()"><span style="cursor:pointer">SEARCH FOR LABEL. SDS & SUPPORTING
                    DOCUMENTS</span>
            </div>
            <div *ngFor="let result of this.productResults" class="col-12">
                <div class="row mb-3">
                    <img style="height:234px;width:234px;" src={{result.ImageURL}}
                        onerror="this.onerror=null; src='https://harrellscomtest.blob.core.windows.net/harrellscomtest/assets/images/ProductPhotos/profertilizer_default.jpg'"
                        alt="fertilizer image">
                    <div style="width:auto">
                        <h6 class="DIN2014Regular"
                            style="font-size:19px;font-weight:700; line-height: 19.2px;letter-spacing: .38px;">
                            {{result.WebName}}</h6>
                        <h6 class="DIN2014Regular"
                            style="font-size:14px;font-weight:700; line-height: 19.2px;letter-spacing: .28px;">
                            {{result.ItemNmbr}}</h6>
                        <a (click)="ViewProductsDetail(result)">
                            <h6 class="DIN2014Regular greenText"
                                style="cursor:pointer;text-decoration:underline; font-size:16px;font-weight:700; line-height: 19.2px;letter-spacing: .28px;">
                                DETAILS</h6>
                        </a>
                        <div class="row whiteBackground">
                            <a class="DIN2014 blueBackground whiteText"
                                style="cursor:pointer;text-align:center; width:70px; font-size:20px; font-weight: 700; padding:8px; text-decoration: none !important"
                                (click)="GetSDS(result.ItemNmbr)">SDS</a>
                            <a class="DIN2014 blueBackground whiteText ml-2"
                                style="cursor:pointer;margin-left:10px;text-align:center; width:85px; font-size:20px; font-weight: 700; padding:8px; text-decoration: none !important"
                                (click)="GetLabel(result.ItemNmbr)">LABEL</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- employees found from search term -->
        <div *ngIf="empResults.length>0" class="row mt-3 mb-5" style="width:80%; max-width:1500px;">
            <h4 class="Caecilia76BoldItalic blackText" style="font-size:26px; font-weight:700">
                Employees
            </h4>
            <div *ngFor="let result of this.empResults" class="col-12">
                <div class="row mb-3">
                    <img style="height:234px;width:234px;" src={{result.ImgURL}} alt="emp image">
                    <div style="width:auto">
                        <h6 class="DIN2014Regular"
                            style="font-size:19px;font-weight:700; line-height: 19.2px;letter-spacing: .38px;">
                            {{result.Name}}</h6>
                        <h6 class="DIN2014Regular"
                            style="font-size:14px;font-weight:700; line-height: 19.2px;letter-spacing: .28px;">
                            {{result.Email}}</h6>
                        <h6 class="DIN2014Regular"
                            style="font-size:14px;font-weight:700; line-height: 19.2px;letter-spacing: .28px;">
                            {{result.Phone}}</h6>
                        <h6 class="DIN2014Regular"
                            style="font-size:14px;font-weight:700; line-height: 19.2px;letter-spacing: .28px;">
                            {{result.Title}}</h6>
                        {{result.Category}}
                        <h5 *ngIf="result.Category != null" class="DIN2014Regular greenText"
                            style="cursor:pointer; text-decoration:underline; font-size:16px;font-weight:700; line-height: 19.2px;letter-spacing: .28px;"
                            (click)="GoToRep(result)">
                            LETS CONNECT</h5>
                    </div>
                </div>
            </div>
        </div>

        <!-- blogs found from search term -->
        <div *ngIf="blogResults.length>0" class="row mb-5" style="width:80%; max-width:1500px">
            <h4 class="Caecilia76BoldItalic blackText" style="font-size:26px; font-weight:700">
                Blogs</h4>
            <div *ngFor="let result of this.blogResults" class="col-12">
                <div class="row mb-3" (click)="GoToBlog(result)" style="cursor:pointer">
                    <img style="height:234px;width:234px;object-fit:cover;object-position: center;"
                        src={{result.ImageName}} alt="emp image">
                    <div style="width:auto">
                        <h6 class="DIN2014Regular"
                            style="font-size:19px;font-weight:700; line-height: 19.2px;letter-spacing: .38px;"
                            [innerHTML]="result.Name">
                        </h6>
                        <h6 class="DIN2014Regular"
                            style="font-size:14px;font-weight:700; line-height: 19.2px;letter-spacing: .28px;">By:
                            {{result.LoggedInUserName}}</h6>
                        <h6 class="DIN2014Regular"
                            style="font-size:14px;font-weight:700; line-height: 19.2px;letter-spacing: .28px;">
                            {{result.RevisionPublishDate}}</h6>
                        <h5 class="DIN2014Regular greenText"
                            style="cursor:pointer; text-decoration:underline; font-size:16px;font-weight:700; line-height: 19.2px;letter-spacing: .28px;">
                            READ ARTICLE</h5>
                    </div>
                </div>
            </div>
        </div>

        <!-- education posts found from search term -->
        <div *ngIf="educationResults.length>0" class="row mb-5" style="width:80%; max-width:1500px">
            <h4 class="Caecilia76BoldItalic blackText" style="font-size:26px; font-weight:700">
                Education</h4>
            <div *ngFor="let result of this.educationResults" class="col-12" style="cursor:pointer">
                <div class="row mb-3" (click)="GoToEducationPostSearchPage(result)">
                    <img style="height:234px;width:234px;object-fit:cover;object-position: center;"
                        src={{result.ImageName}} alt="emp image">
                    <div style="width:auto">
                        <h6 class="DIN2014Regular"
                            style="font-size:19px;font-weight:700; line-height: 19.2px;letter-spacing: .38px;"
                            [innerHTML]="result.Name">
                        </h6>
                        <h6 class="DIN2014Regular"
                            style="font-size:14px;font-weight:700; line-height: 19.2px;letter-spacing: .28px;">By:
                            {{result.LoggedInUserName}}</h6>
                        <h6 class="DIN2014Regular"
                            style="font-size:14px;font-weight:700; line-height: 19.2px;letter-spacing: .28px;">
                            {{result.RevisionPublishDate}}</h6>
                        <!-- <h5 class="DIN2014Regular greenText"
                            style="cursor:pointer; text-decoration:underline; font-size:16px;font-weight:700; line-height: 19.2px;letter-spacing: .28px;">
                            READ ARTICLE</h5> -->

                        <h5 class="DIN2014Regular greenText" *ngIf="!result.IsMatrixPost"
                            style="cursor:pointer; margin-top:20px; font-size:16px; line-height: 19px; font-weight:700; text-decoration-line: underline;">
                            READ ARTICLE ></h5>
                        <h5 class="DIN2014Regular greenText " *ngIf="(this.loggedInUser && result.IsMatrixPost) "
                            style="cursor:pointer; margin-top:20px; font-size:16px; line-height: 19px; font-weight:700; text-decoration-line: underline;">
                            VIEW COURSE ></h5>
                        <h5 class="DIN2014Regular greenText "
                            *ngIf="((!this.loggedInUser || this.loggedInUser == '') && result.IsMatrixPost) "
                            style="cursor:pointer; margin-top:20px; font-size:16px; line-height: 19px; font-weight:700; text-decoration-line: underline;">
                            LOG IN TO VIEW COURSE ></h5>



                    </div>
                </div>
            </div>
        </div>

        <!-- invoices found from search term -->
        <div *ngIf="invoiceResults.length>0" class="row mb-5" style="width:80%; max-width:1500px">
            <h4 class="Caecilia76BoldItalic blackText" style="font-size:26px; font-weight:700">
                Invoices</h4>
            <div *ngFor="let result of this.invoiceResults" class="col-12">
                <div class="row mb-3">
                    <img style="height:234px;width:234px;object-fit:cover;object-position: center;"
                        src={{result.ImageName}} alt="emp image">
                    <div style="width:auto">
                        <h6 class="DIN2014Regular"
                            style="font-size:19px;font-weight:700; line-height: 19.2px;letter-spacing: .38px;">
                            {{result.SOPNumber}}</h6>
                        <h6 class="DIN2014Regular"
                            style="font-size:14px;font-weight:700; line-height: 19.2px;letter-spacing: .28px;">
                            {{result.DocumentDate}}</h6>
                        <h5 class="DIN2014Regular greenText"
                            style="cursor:pointer; text-decoration:underline; font-size:16px;font-weight:700; line-height: 19.2px;letter-spacing: .28px;"
                            (click)="OpenPdfDoc('Invoice',result.SOPNumber)">
                            VIEW INVOICE</h5>
                    </div>
                </div>
            </div>
        </div>
        <div *ngIf="searchSubmitted && dotComService.searchTerm != '' && productResults.length==0 && blogResults.length==0 && empResults.length==0 && invoiceResults.length==0"
            class="row mt-3 mb-5">
            <h4 class="DIN2014Regular blackText" style="font-size:19px; font-weight:400">
                No results found. Please verify your search term and try again.
            </h4>
        </div>
    </div>
</div>